import Splide from '@splidejs/splide'

import { getElementChild, getElements } from '../../../../Resources/Private/TypeScript/Utility/Dom'

class HeroSlider {
  private sliders: NodeListOf<HTMLElement>

  constructor() {
    this.sliders = getElements('hero-slider')
  }

  public init(): void {
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches

    this.sliders.forEach((slider: HTMLElement): void => {
      const splide = new Splide(slider, {
        arrows: true,
        autoplay: true,
        i18n: {
          first: slider.getAttribute('data-label-first'),
          last: slider.getAttribute('data-label-last'),
          next: slider.getAttribute('data-label-next'),
          prev: slider.getAttribute('data-label-prev'),
          slide: slider.getAttribute('data-label-slide'),
        },
        interval: 6000,
        pagination: true,
        pauseOnFocus: false,
        pauseOnHover: false,
        perPage: 1,
        resetProgress: false,
        speed: 600,
        type: 'loop',
      })

      splide.mount()

      const pagination = splide.root.querySelector<HTMLElement>('.splide__pagination')

      this.relocateControls(slider, splide)
      this.setupAutoplayProgress(splide, pagination)
      this.setupPauseButton(slider, splide, prefersReducedMotion)
    })
  }

  private relocateControls(slider: HTMLElement, splide: Splide): void {
    const controls = getElementChild(slider.parentElement, 'hero-slider-controls')
    if (controls === null) {
      return
    }

    const pagination = splide.root.querySelector('.splide__pagination')
    const arrows = splide.root.querySelector('.splide__arrows')

    if (arrows !== null) {
      controls.prepend(arrows)
    }

    if (pagination !== null) {
      controls.prepend(pagination)
    }
  }

  private setupAutoplayProgress(splide: Splide, pagination: HTMLElement | null): void {
    if (pagination === null || splide.options.autoplay === false) {
      return
    }

    pagination.classList.add('is-autoplay')

    splide.on('autoplay:playing', (rate: number): void => {
      pagination.style.setProperty('--slider-autoplay-progress', String(rate))
    })
  }

  private setupPauseButton(slider: HTMLElement, splide: Splide, startPaused: boolean): void {
    const pauseButton = getElementChild(slider.parentElement, 'hero-slider-pause')
    if (pauseButton === null) {
      return
    }

    let paused = startPaused

    const update = (): void => {
      if (paused === true) {
        splide.Components.Autoplay?.pause()
      } else {
        splide.Components.Autoplay?.play()
      }

      pauseButton.setAttribute('aria-pressed', String(paused))
      pauseButton.setAttribute('aria-label', pauseButton.getAttribute(paused === true ? 'data-label-play' : 'data-label-pause'))
      pauseButton.classList.toggle('is-paused', paused)
    }

    update()

    pauseButton.addEventListener('click', (): void => {
      paused = !paused
      update()
    })
  }
}

const heroSlider = new HeroSlider()
heroSlider.init()
